import JWTApi, { IUser } from "../libs/login/JWTApi";
import { TPermission } from "../libs/login/Permission";
import { FMFile, IFile } from "../shared/FMFile";
import { GDir } from "./Dirs";

export type TFManUser = IUser & {
    permissions:string[]
}

export type TConfligResolution="none"|"replace"|"rename"
export default class FManApi extends JWTApi<TFManUser> {
    static _i:FManApi
    static get i(){
        if (!this._i) this._i = new FManApi()
        return this._i
    }
    protected onVerified(user: TFManUser): Promise<TFManUser> {
        return this.api.get<TPermission>("/1/permissions/me").then(data => {
            return {...user,permissions:data.data.permissions}
        })
    }
    getFile(fileId:string){
        return this.api.get<string>("/1/files/"+fileId).then(data => FMFile.deserialize(data.data))
    }
    getFiles(fileIds:string[]){
        return this.api.get<string[]>("/1/files/" + fileIds.join(",") + ",").then(data => data.data.map(file => FMFile.deserialize(file)))
    }
    getDirs(){
        return this.api.get<string[]>("/1/dirs").then(data => data.data.map(dir => GDir.deserialize(dir)))
    }
    createDirs(rootId:string, path:string){
        return this.api.post<string[]>("/1/dirs/"+rootId, {path}).then(data => data.data.map(dir => GDir.deserialize(dir)))
    }
    deleteFile(fileIds:string[], recursive:boolean){
        return this.api.delete<any>("/1/files/"+fileIds.join(",")+(recursive?"?recursive=1":""))
    }
    createSession(rootId:string, name:string, size:number, conflictResolution:TConfligResolution){
        return this.api.post<IFile>("/1/files/"+rootId+"?conflict="+conflictResolution, {name,size}).then(data => new FMFile(data.data))
    }
    appendFile(fileId:string, offset:number, buffer:Uint8Array){
        return this.api.put<IFile>(`/1/files/${fileId}/${offset}`, buffer, {headers:{"content-type":"application/octet-stream"}}).then(data => new FMFile(data.data))
    }
    renameFile(fileId:string, name:string){
        return this.api.put<IFile>(`/1/files/${fileId}/name`, JSON.stringify(name)).then(data => new FMFile(data.data))
    }

    getContent(fileId:string){
        return this.api.get<any>("/1/contents/"+fileId).then(data => data.data)
    }
    shareFiles(fileIds:string[],duration:number){
        return this.api.post<string>("/1/share", {fileIds,duration}).then(data => data.data)
    }
}